<template>
    <div class="home">
        <div class="swipe">
            <mt-swipe :auto="4000">
                <mt-swipe-item v-if="swipeShow">
                    <div>
                        <img src="./images/banner2.png" alt class="picture" />
                    </div>
                </mt-swipe-item>
                <mt-swipe-item>
                    <div class="picture" @click="onRouterLink">
                        <img src="https://cache.galaxy-immi.com/H5/img/banner_jf.png" alt class="picture" />
                    </div>
                </mt-swipe-item>
                <!-- <mt-swipe-item>
        <div class="picture" style="background: #ff2d4b;"></div>
        </mt-swipe-item> -->
            </mt-swipe>
        </div>
        <div class="con-bg">
            <div class="register">
                <div class="register-left"></div>
                <div class="register-right" v-if="loading" key="loading">
                    加载中……
                </div>
                <div class="register-right" v-else key="loading">
                    <div class="title" v-if="userinfo.phone">我的积分</div>
                    <div class="integral" v-if="userinfo.phone">
                        {{ userinfo.points === "0" ? "- -" : userinfo.points }}
                    </div>
                    <div class="describe">
                        {{
                            userinfo.phone
                                ? "赚积分，换豪礼"
                                : "注册会员，立即领取30积分"
                        }}
                    </div>
                    <div class="register-button" @click="$router.push('/personalCenter')" v-if="userinfo.phone">
                        会员中心
                    </div>
                    <div class="register-button" @click="$router.push('/registeredVip')" v-else>
                        注册会员
                    </div>
                </div>
            </div>
            <div class="merc-list">
                <div class="title-box">
                    <div class="title">热门推荐</div>
                    <div class="more" @click="$router.push('/shoplist')">
                        更多
                        <span></span>
                    </div>
                </div>
                <div class="list-box">
                    <div class="list">
                        <div class="list-item" v-for="item in list" @click="$router.push(`/shopdetail?id=${item.id}`)" :key="item.id">
                            <img :src="item.litimg_url" alt />
                            <div class="title">{{ item.goods_name }}</div>
                            <div class="list-integral">
                                <span>{{ item.integral_price }}</span> 积分
                            </div>
                        </div>
                    </div>
                    <div class="more-text">更多商品请点击更多！</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
if (getQueryVariable("code")) {
    history.pushState(
        {
            page: 1,
        },
        null,
        window.location.href
    );
}
function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return false;
}
import {
    getHotgoodslist,
    getuserinfo,
    wx_signature,
    checkIntegralHandle,
} from "../../../api/api-config";
import { MessageBox, Toast } from "mint-ui";
import wxShare from "../../../untils/wx_share.js";
import storage from "../../../untils/storage";
export default {
    props: {},
    data() {
        return {
            list: [],
            userinfo: {},
            vxdata: {
                token: "",
                isvx: 0, //1是 0否
            }, //微信传过来的值
            loading: true
        };
    },
    computed: {
        swipeShow() {
            return new Date().getTime() <
                new Date("2020-2-1 00:00:00").getTime()
                ? true
                : false;
        },
    },
    created() {
        // h5内嵌页面 获取页面携带参数
        let result = {};
        let str = location.href;
        let reg = /[\?&]([^=]*)=([^&/]*)/g;
        while (reg.test(str)) {
            result[RegExp.$1] = RegExp.$2;
        }
        if (result.isvx === "1") {
            // 是否微信内嵌跳过来
            this.$Cookie.set("isvx", result.isvx);
            const token = decodeURIComponent(result.token);
            // storage.setToken(token);
            this.vxdata = {
                token: token,
                isvx: result.isvx, //1是 0否
            };
        }

        this.getList();
        this.wxSignature();
    },
    mounted() {},
    watch: {},
    methods: {
        syncPoints() {
            MessageBox.confirm("确认同步智汇银河小程序积分？").then(
                (action) => {
                    // 先判断一下有没有注册
                    if (!this.userinfo.phone) {
                        this.$router.push({
                            path: "/personalCenter",
                        });
                        return false;
                    }
                    checkIntegralHandle({
                        mobile: this.userinfo.phone,
                    }).then((res) => {
                        console.log(res);
                        if (res.data.code === 200) {
                            // 更新一下积分
                            this.getuserinfo();
                            return Toast({
                                message: "操作成功！",
                                iconClass: "icon icon-success",
                            });
                        }
                        Toast({
                            message: res.data.msg,
                        });
                    });
                }
            );
        },
        onRouterLink() {
            return; //window.location = "/recommend";
        },
        wxSignature() {
            // let url =   window.location.href ;
            //  let doman =window.location.href.split('?')[0];

            let sinUrl = window.location.href;

            wx_signature({
                url: sinUrl,
            })
                .then((res) => {
                    const r = res.data;
                    if (r.code == 200) {
                        wxShare.getMsg = r.data;
                        wxShare.shareData = {
                            share_title: "您有好礼待兑换，快进来看看！",
                            share_description:
                                "银河积分商城会员专享好礼，快来换豪礼吧！",
                            share_thumb:
                                "https://file.galaxy-immi.com/wxapi.galaxy-immi.com/share_img.png",
                            link: sinUrl,
                        };
                        //  console.log(wxShare.shareData)
                        wxShare.init();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        // 判断是否微信
        getList() {
            if (this.vxdata.isvx === "1") {
                // 微信内嵌h5 判断是否有token 如果token为空 说明h5这边没这个人
                if (this.vxdata.token === "") {
                    this.$router.push({
                        path: "/",
                    });
                } else {
                    this.getHotgoodslist();
                    this.getuserinfo();
                }
            } else {
                this.getHotgoodslist();
                this.getuserinfo();
            }
        },
        // 获取列表
        async getHotgoodslist() {
            this.$indicator.open();
            const res = await getHotgoodslist();
            const data = res.data;
            if (data.code === 200) {
                this.list = data.data;
            } else {
                Toast(data.msg);
            }
            this.$indicator.close();
        },
        async getuserinfo() {
            this.loading = true;
            const res = await getuserinfo();
            this.loading = false;
            const data = res.data;
            if (data.code === 200) {
                this.userinfo = data.data;
                this.$Cookie.set("userinfo", JSON.stringify(data.data));
            }
        },
    },
    components: {},
};
</script>
<style scoped lang="scss">
.home {
    background: #b22924;
    min-height: 100vh;
}

.swipe {
    height: rem(358);

    /deep/.mint-swipe-indicators {
        /deep/.mint-swipe-indicator {
            width: 0.7rem;
            height: 0.2rem;
            background: rgba(255, 255, 255, 0.5);
            opacity: 0.55;
            border-radius: 0;
        }

        /deep/.is-active {
            background: #fff;
        }
    }
}

.picture {
    width: 100%;
    height: 100%;
}

.con-bg {
    width: 100%;
    background: url("https://cache.galaxy-immi.com/H5/img/bg_jf.jpg") no-repeat;
    background-size: 100% 46%;
    padding-top: rem(45);
}

.register {
    display: flex;
    margin: rem(0) rem(36) 0 rem(18);
    border-radius: rem(10);
    background: #fff;
    height: rem(210);
    justify-content: center;
    align-items: center;
    padding-left: rem(50);

    .register-left {
        width: rem(155);
        height: rem(155);
        background: url("./images/home_Pointreward.png") no-repeat;
        background-size: 100% 100%;
        margin-right: rem(34);
    }

    .register-right {
        flex: 1;
        position: relative;

        .title {
            font-size: rem(30);
            font-weight: 800;
            color: #333;
            // margin-top: rem(32);
        }

        .integral {
            font-size: rem(44);
            color: #ff5d00;
            font-weight: 800;
        }

        .describe {
            font-size: rem(24);
            color: #ef382d;
            margin-top: rem(6);
        }

        .register-button {
            width: rem(170);
            height: rem(64);
            background: linear-gradient(159deg, #eb5149, #be1e14);
            box-shadow: 0px rem(2) rem(6) 0px rgba(178, 41, 36, 0.71);
            border-radius: rem(64);
            position: absolute;
            top: rem(0);
            right: rem(25);
            line-height: rem(60);
            text-align: center;
            font-size: rem(26);
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
        }
    }
}

.merc-list {
    margin: rem(52) 0 0 0;

    .title-box {
        margin: 0 rem(34);
        position: relative;

        .title {
            font-size: rem(38);
            font-weight: bold;
            color: #fff;
            font-family: Source Han Sans CN;
            letter-spacing: 3px;
        }

        .more {
            position: absolute;
            top: rem(10);
            right: 0;
            font-size: rem(26);
            color: #fff;

            & > span {
                display: inline-block;
                width: rem(36);
                height: rem(36);
                background: url("https://cache.galaxy-immi.com/H5/img/more_jf.png")
                    no-repeat;
                background-size: 100% 100%;
                margin-left: rem(4);
                vertical-align: middle;
                margin-bottom: rem(6);
            }
        }
    }

    .list-box {
        width: 100%;
        // height: rem(2000);
        // background: url("./images/home_bg.png") no-repeat;
        // background-size: 100% rem(2000);
        margin-top: rem(32);
    }

    .list {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        margin: 0 rem(34);

        .list-item {
            width: rem(340);
            height: rem(400);
            box-shadow: 2px 2px 15px 2px rgba(90, 90, 90, 0.1);
            border-radius: rem(10);
            text-align: center;
            margin-bottom: rem(22);
            background: #fff;
            font-size: 0px;

            img {
                margin-top: rem(30);
                width: rem(240);
                height: rem(240);
                margin-bottom: 0;
            }

            .title {
                font-size: rem(28);
                color: #333;
                padding: 0 rem(20);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-top: rem(8);
                margin-bottom: rem(5);
            }

            .list-integral {
                font-size: rem(26);
                color: #333;

                & > span {
                    font-size: rem(32);
                    font-weight: 600;
                    color: #ef382d;
                }
            }
        }
    }

    .more-text {
        padding: rem(44) 0 rem(58) 0;
        font-size: rem(24);
        color: #fff;
        text-align: center;
        opacity: 0.6;
        font-family: PingFang SC;
        font-weight: 400;
        letter-spacing: 2px;
    }
}
</style>